import { CircleHelpIcon, Maximize2Icon, Minimize2Icon } from 'lucide-react';
import { TooltipIconButton } from '@/components/assistant-ui/tooltip-icon-button';
import { McpAutoBudgetDoubleHint } from './McpAutoBudgetDoubleHint';
import { McpHistoryToggleButton } from './McpChatHistorySidebar';
import { useOptionalMcpHelpMode } from './McpHelpModeContext';

type McpChatHeaderProps = {
  historyOpen: boolean;
  onToggleHistory: () => void;
  fullscreen?: boolean;
  onToggleFullscreen?: () => void;
};

export function McpChatHeader({
  historyOpen,
  onToggleHistory,
  fullscreen = false,
  onToggleFullscreen
}: McpChatHeaderProps) {
  const help = useOptionalMcpHelpMode();
  const helpMode = help?.helpMode ?? false;
  const fullscreenLabel = fullscreen ? 'خروج از تمام‌صفحه' : 'تمام‌صفحه';
  const helpTooltip = 'راهنمای ابزار - به زودی';

  return (
    <header className="mcp-chat-header">
      <div className="d-flex align-items-center gap-2 min-w-0">
        <McpHistoryToggleButton
          open={historyOpen}
          onToggle={onToggleHistory}
        />
        <h1 className="mcp-chat-header-heading">
          {helpMode ? 'راهنمای میزفاتولز' : 'دستیار AI میزفاتولز'}
        </h1>
      </div>
      <div className="d-flex align-items-center gap-1.5">
        {helpMode ? null : <McpAutoBudgetDoubleHint />}
        {onToggleFullscreen ? (
          <TooltipIconButton
            tooltip={fullscreenLabel}
            side="bottom"
            type="button"
            variant="ghost"
            size="icon"
            className="mcp-chat-pill-btn mcp-chat-pill-btn--sm mcp-chat-pill-btn--icon"
            onClick={onToggleFullscreen}
            aria-pressed={fullscreen}
            aria-label={fullscreenLabel}
          >
            {fullscreen ? (
              <Minimize2Icon size={13} strokeWidth={2.25} />
            ) : (
              <Maximize2Icon size={13} strokeWidth={2.25} />
            )}
          </TooltipIconButton>
        ) : null}
        {help && !helpMode ? (
          <TooltipIconButton
            tooltip={helpTooltip}
            side="bottom"
            type="button"
            variant="ghost"
            size="icon"
            className="mcp-chat-pill-btn mcp-chat-pill-btn--ghost mcp-chat-pill-btn--sm mcp-chat-pill-btn--icon mcp-chat-header-help-icon"
            aria-disabled
            aria-label={helpTooltip}
            onClick={event => {
              event.preventDefault();
            }}
          >
            <CircleHelpIcon size={13} strokeWidth={2.25} />
          </TooltipIconButton>
        ) : null}
      </div>
    </header>
  );
}
